<div
  class="app-loader"
  [class.full-screen]="fullScreen()"
  [class]="'app-loader-size-' + size()"
  [style.min-height]="minHeight()"
>
  <div class="app-loader-stage" role="status" aria-live="polite">
    @if (fullScreen()) {
      <!-- Full-screen splash — vertical Harvey-clean lockup:
           mark (inline SVG) above wordmark (HTML text so typography
           tracks the design tokens), hairline attestation track below.
           Composition is dead-centered via the stage's absolute
           positioning; motion is a considered fade-in for the whole
           cluster + a slow dwelling sweep on the track. -->
      <div class="app-loader-cluster">
        <svg
          class="app-loader-mark-svg"
          viewBox="0 0 642 511"
          role="img"
          [attr.aria-label]="brandName"
          preserveAspectRatio="xMidYMid meet"
        >
          <path
            class="app-loader-mark-glyph"
            fill-rule="evenodd"
            d="M 609.587 2.750 C 609.177 3.163, 602.240 3.831, 594.171 4.235 C 540.581 6.922, 536.983 7.845, 517.173 23.995 C 497.858 39.741, 398.517 141.783, 378.091 166.859 C 375.116 170.512, 369.041 177.653, 364.591 182.728 C 347.560 202.153, 321.942 233.837, 306.750 254.266 C 301.631 261.149, 301.863 262.441, 309.587 270.029 C 316.209 276.533, 324.474 287.917, 326.629 293.500 C 331.710 306.665, 332.157 309.474, 331.722 325.500 C 331.249 342.907, 329.889 349.375, 324.888 358 C 324.409 358.825, 322.930 361.525, 321.600 364 C 319.337 368.213, 302.213 385.558, 295.045 390.898 C 291.501 393.538, 291.397 395.215, 293.980 408 C 294.591 411.025, 295.500 415.975, 296 419 C 296.500 422.025, 297.394 426.975, 297.988 430 C 298.581 433.025, 299.490 437.975, 300.007 441 C 300.525 444.025, 301.438 448.525, 302.038 451 C 302.637 453.475, 303.537 457.975, 304.038 461 C 304.538 464.025, 305.444 468.525, 306.050 471 C 306.656 473.475, 307.534 477.975, 308 481 C 308.466 484.025, 309.368 488.525, 310.004 491 C 310.641 493.475, 311.462 497.714, 311.831 500.421 C 312.819 507.683, 314.136 507.037, 318.990 496.907 C 321.397 491.884, 324.913 485.238, 326.804 482.137 C 328.695 479.037, 331.477 473.928, 332.985 470.785 C 335.543 465.453, 341.064 455.486, 348.750 442.324 C 350.537 439.262, 354.580 431.750, 357.734 425.629 C 360.887 419.508, 363.735 414.275, 364.062 414 C 364.390 413.725, 365.972 411.025, 367.578 408 C 369.184 404.975, 370.991 401.976, 371.593 401.335 C 372.194 400.695, 373.292 398.670, 374.032 396.835 C 374.772 395.001, 376.367 392.150, 377.577 390.500 C 378.787 388.850, 380.960 385.250, 382.407 382.500 C 387.780 372.290, 421.875 315.609, 430.622 302.345 C 433.580 297.860, 436 293.904, 436 293.553 C 436 293.203, 436.452 292.372, 437.005 291.708 C 437.557 291.044, 441.459 285.100, 445.676 278.500 C 455.402 263.277, 470.562 240.495, 479.823 227.186 C 483.770 221.513, 487 216.692, 487 216.472 C 487 215.573, 519.932 169.807, 524.234 164.728 C 525.738 162.953, 526.975 160.938, 526.984 160.250 C 526.993 159.563, 527.389 159, 527.864 159 C 528.339 159, 530.027 157.096, 531.614 154.770 C 533.201 152.443, 535.251 149.631, 536.170 148.520 C 537.088 147.409, 542.716 140.200, 548.675 132.500 C 566.469 109.509, 591.247 79.090, 602.436 66.500 C 606.346 62.100, 610.710 56.925, 612.133 55 C 613.557 53.075, 619.093 46.775, 624.436 41 C 633.885 30.787, 640.019 21.120, 639.983 16.500 C 639.955 12.905, 635.565 6.601, 631.480 4.287 C 627.435 1.996, 611.453 0.874, 609.587 2.750 M 19 266.991 C 18.175 267.529, 16.015 267.976, 14.200 267.985 C 0.516 268.048, -2.678 287.088, 9.682 294.919 C 19.674 301.250, 22.007 302.840, 29 308.087 C 58.266 330.044, 127.209 401.284, 155.500 438.802 C 166.925 453.953, 173.313 462.946, 182.493 476.803 C 194.112 494.339, 194.743 494.764, 196.176 486.024 C 196.629 483.261, 197.471 478.637, 198.046 475.750 C 198.621 472.863, 199.500 468.025, 200 465 C 200.500 461.975, 201.405 457.025, 202.011 454 C 202.617 450.975, 203.512 445.575, 204 442 C 204.488 438.425, 205.360 433.025, 205.939 430 C 206.518 426.975, 207.429 422.025, 207.963 419 C 208.497 415.975, 209.422 411.025, 210.018 408 C 212.761 394.079, 212.497 392.723, 206.207 388.455 C 196.398 381.799, 193.510 379.345, 189.356 374.131 C 184.352 367.850, 174 348.179, 174 344.951 C 174 343.806, 173.520 341.971, 172.933 340.875 C 172.312 339.715, 171.861 332.474, 171.853 323.555 C 171.839 306.991, 173.547 298.890, 178.714 291.018 C 182.453 285.322, 181.860 283.747, 174.032 278.590 C 170.200 276.066, 166.578 274, 165.983 274 C 165.388 274, 163.461 273.249, 161.700 272.331 C 158.015 270.409, 153.373 269.251, 143.500 267.788 C 134.152 266.404, 21.011 265.679, 19 266.991"
          />
        </svg>
        <span class="app-loader-wordmark">{{ brandName }}</span>
        <div class="app-loader-track" aria-hidden="true">
          <span class="app-loader-track-glide"></span>
        </div>
      </div>
    } @else {
      <div class="app-loader-mark">
        @if (logoSrc(); as src) {
          <img
            class="app-loader-mark-image"
            [ngSrc]="src"
            [alt]="brandName + ' logo'"
            width="1024"
            height="1024"
            priority
          />
        } @else {
          <svg
            class="app-loader-svg"
            viewBox="0 0 100 100"
            aria-hidden="true"
            preserveAspectRatio="xMidYMid meet"
          >
            <path class="app-loader-mark-brand" d="M22 50 L50 72 L78 28" />
          </svg>
        }
      </div>

      @if (title()) {
        <h3 class="app-loader-title">{{ title() }}</h3>
      }
      @if (description(); as d) {
        <p class="app-loader-description">{{ d }}</p>
      }

      <div class="app-loader-progress" aria-hidden="true">
        <div class="app-loader-progress-shimmer"></div>
      </div>

      @if (slowHint()) {
        <p class="app-loader-slow-hint">Still loading…</p>
      }
    }

    <span class="app-loader-sr">{{ title() ?? 'Loading' }}</span>
  </div>

  @if (fullScreen() && slowHint()) {
    <!-- A sibling of the stage, not a child: the stage is absolutely positioned and transformed, so a
         descendant would anchor to the small centred lockup (and wrap into it) instead of the screen. -->
    <p class="app-loader-hint">{{ slowHintLabel }}</p>
  }
</div>
